<template>
    <div>
        <button id="filtersButton1" v-if="classificationPlan.length > 0" class="btn btn-primary mb-4"
                @click="setCurrentFiltersCopy();$bvModal.show(modalName); {showFilters = false}"><i
                class="fas fa-filter"></i>
            {{$t('text.classificationPlanFilter.filterClearButtons.filters')}}
        </button>
        <div class="btn-group mb-4" role="group" aria-label="Basic example">
            <button v-if="toExport || toPrint" type="button" class="btn btn-primary" @click="emitCheckAll(true)">{{$t('text.classificationPlanFilter.selectButtons.selectAll')}}</button>
            <button  v-if="toExport || toPrint" type="button" class="btn btn-primary" @click="emitCheckAll(false)">{{$t('text.classificationPlanFilter.selectButtons.deselectAll')}}</button>
        </div>


        <ul v-if="showFilters" class="filterButtons">
            <li v-if='filters.label !== "none"'>
                {{$t('text.classificationPlanMetadata.classificationLabel')}}: <b>{{ filters.label }}</b>
                <button id="clearLabelButton1" class="" @click="clearLabel">
                    <i class="fa fa-times"></i>
                </button>
            </li>
            <li v-if='filters.labelName !== "none"'>
                {{$t('text.classificationPlanMetadata.classificationLabelName')}}: <b>{{ filters.labelName }}</b>
                <button id="clearLabelNameButton1" class="" @click="clearLabelName">
                    <i class="fa fa-times"></i>
                </button>
            </li>
            <li v-if='filters.povezaniSistemi !== "none"'>
                {{$t('text.classificationPlanMetadata.connectedSystems')}}: <b>{{ filters.povezaniSistemi }}</b>
                <button id="clearPovezaniSistemiButton1" class="" @click="clearPovezaniSistemi">
                    <i class="fa fa-times"></i>
                </button>
            </li>
            <li v-if='filters.rokHrambe !== "none"'>
                {{$t('text.classificationPlanMetadata.expiration')}}: <b>{{ filters.rokHrambe }}</b>
                <button id="clearRokHrambe1" class="" @click="clearRokHrambe">
                    <i class="fa fa-times"></i>
                </button>
            </li>
            <li v-if='filters.vrstaGradiva !== "none"'>
                {{$t('text.classificationPlanMetadata.expirationType')}}: <b>{{ filters.vrstaGradiva }}</b>
                <button id="clearVrstaGradicaButton1" class="" @click="clearVrstaGradiva">
                    <i class="fa fa-times"></i>
                </button>
            </li>
            <li v-if='filters.vpisnik !== "none"'>
                {{$t('text.classificationPlanMetadata.registry')}}: <b>{{ filters.vpisnik }}</b>
                <button id="clearVpisnikButton1" class="" @click="clearVpisnik">
                    <i class="fa fa-times"></i>
                </button>
            </li>
            <li v-if="filters.creationDate && (filters.creationDate.start != null || filters.creationDate.start != null)">
                {{$t('text.classificationPlanMetadata.creationDate')}}: <b>{{filters.creationDate.start}}-{{filters.creationDate.end}}</b>
                <button id="clearCreationDateButton1" class="" @click="clearCreationDate">
                    <i class="fa fa-times"></i>
                </button>
            </li>
            <li v-if="filters.usageEndDate && (filters.usageEndDate.start != null || filters.usageEndDate.end != null)">
                {{$t('text.classificationPlanMetadata.usageEndDate')}}: <b>{{ filters.usageEndDate.start }}-{{ filters.usageEndDate.end}}</b>
                <button id="clearUsageEndDateButton1" class="" @click="clearUsageEndDate">
                    <i class="fa fa-times"></i>
                </button>
            </li>
        </ul>

        <b-modal
                centered
                size="lg"
                :id="modalName"
                :title="$t('text.classificationPlanFilter.filterSelectModal.selectFilter')"
                @close="modalClose">
            <b-row class="pb-2">
                <b-col class="my-1">
                    <div class="left1">{{$t('text.classificationPlanMetadata.classificationLabel')}}</div>
                    <div class="right1">
                        <v-select :options="filterOptionsLabel" v-model="filters.label">
                            <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                        </v-select>
                    </div>
                </b-col>
            </b-row>
            <b-row class="pb-2">
                <b-col class="my-1">
                    <div class="left1">
                        {{$t('text.classificationPlanMetadata.classificationLabelName')}}
                    </div>
                    <div class="right1">
                        <v-select :options="filterOptionsLabelName" v-model="filters.labelName">
                            <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                        </v-select>
                    </div>
                </b-col>
            </b-row>
            <b-row class="pb-2">
                <b-col class="my-1">
                    <div class="left1">
                        {{$t('text.classificationPlanMetadata.connectedSystems')}}
                    </div>
                    <div class="right1">
                        <v-select :options="filterOptionsPovezaniSistemi" v-model="filters.povezaniSistemi">
                            <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                        </v-select>
                    </div>
                </b-col>
            </b-row>
            <b-row class="pb-2">
                <b-col class="my-1">
                    <div class="left1">
                        {{$t('text.classificationPlanMetadata.registry')}}
                    </div>
                    <div class="right1">
                        <v-select :options="filterOptionsVpisnik" v-model="filters.vpisnik">
                            <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                        </v-select>
                    </div>
                </b-col>
            </b-row>
            <b-row class="pb-2">
                <b-col class="my-1">
                    <div class="left1">
                        {{$t('text.classificationPlanMetadata.expiration')}}
                    </div>
                    <div class="right1">
                        <v-select :options="filterOptionsRokHrambe" v-model="filters.rokHrambe">
                            <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                        </v-select>
                    </div>
                </b-col>
            </b-row>
            <b-row class="pb-2">
                <b-col class="my-1">
                    <div class="left1">
                        {{$t('text.classificationPlanMetadata.expirationType')}}
                    </div>
                    <div class="right1">
                        <v-select :options="filterOptionsVrstaGradiva" v-model="filters.vrstaGradiva">
                            <span slot="no-options">{{$t('text.globals.noOptions')}}</span>
                        </v-select>
                    </div>
                </b-col>
            </b-row>
            <b-row class="pb-2">
                <b-col class="my-1">
                    <div class="left1">
                        {{$t('text.classificationPlanMetadata.creationDate')}}
                    </div>
                    <div class="right1">
                        <vue-ctk-date-time-picker :label="$t('text.classificationPlanFilter.filterSelectModal.selectCreationDate')" format="DD/MM/YYYY" :range="true" :hint="$t('text.classificationPlanFilter.filterSelectModal.selectLowerBound')" :only-date="true" v-model="filters.creationDate" locale="sl" :custom-shortcuts="$t('text.globals.customDatePickerShortcuts')"/>
                    </div>
                </b-col>
            </b-row>
            <b-row class="pb-2">
                <b-col class="my-1">
                    <div class="left1">
                        {{$t('text.classificationPlanMetadata.usageEndDate')}}
                    </div>
                    <div class="right1">
                        <vue-ctk-date-time-picker :label="$t('text.classificationPlanFilter.filterSelectModal.selectUsageEndDate')" format="DD/MM/YYYY" :range="true" :hint="$t('text.classificationPlanFilter.filterSelectModal.selectLowerBound')" :only-date="true" v-model="filters.usageEndDate" locale="sl" :custom-shortcuts="$t('text.globals.customDatePickerShortcuts')"/>
                    </div>
                </b-col>
            </b-row>
            <div slot="modal-footer" class="w-100">
                <b-button id="filterSaveButton1" class="float-right mr-0" variant="primary"
                          @click="$bvModal.hide(modalName); filter(); updateFilter(); {showFilters = true}">{{$t('text.globals.accept')}}
                </b-button>
                <b-button id="filterPreviousButton1" class="float-left" variant="secondary"
                          @click="$bvModal.hide(modalName); cancelChanges(); {showFilters = true};">{{$t('text.globals.cancel')}}
                </b-button>
            </div>
        </b-modal>

        <div class="classificationPlanEditor mb-5" style="border: none">
            <div class="actionItem">
                <div v-if="classificationPlan.length === 0" style="margin-top: 2%; display: inline-block;"
                     class="alert alert-warning" role="alert">
                    {{$t('text.classificationPlanFilter.noClassificationPlanToShow')}}
                </div>
                <div v-else-if="initialMount" class="bg-light p-3 classificationPlanTreeStructureContainer">

                    <TreeStructure
                            :to-export="toExport || toPrint"
                            :classificationPlan="classificationPlanFilteredStore"
                            :printMode="false"
                            :to-review="true"
                            :showPopover="true"
                            :showErrors="true"
                    ></TreeStructure>

                </div>
                <div v-else-if="!initialMount && filteredClassesFinal.length > 0 && !toExport && !toPrint"
                     class="bg-light p-3 classificationPlanTreeStructureContainer">

                    <TreeStructure
                            :classificationPlan="classificationPlanFilteredStore"
                            :printMode="false"
                            :to-export="toExport"
                            :to-review="true"
                            :showPopover="true"
                            :showErrors="true"
                    ></TreeStructure>

                </div>
                <div v-else-if="!initialMount && toExport && constructedClasses.length > 0 || toPrint && constructedClasses.length > 0"
                     class="bg-light p-3 classificationPlanTreeStructureContainer">

                    <TreeStructure
                            :classificationPlan="constructedClasses"
                            :printMode="false"
                            :to-export="true"
                            :to-review="true"
                            :showPopover="true"
                            :showErrors="true"
                    ></TreeStructure>

                </div>
                <div v-else style="margin-top: 2%; display: inline-block;" class="alert alert-warning" role="alert">
                    {{$t('text.classificationPlanFilter.noClassMatchingSelectedFilters')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import TreeStructure from '../components/TreeStructure'
    import vSelect from 'vue-select';
    import 'vue-select/dist/vue-select.css';
    import Datepicker from 'vuejs-datepicker';

    export default {
        name: "ClassificationPlanFilter",

        props: {
            toExport: {
                type: Boolean,
                default: false
            },
            toPrint: {
                type: Boolean,
                default: false
            },

            id: Number,

            modalName: {
                type: String,
                default: 'modal-filterLabel'
            },
        },

        components: {
            TreeStructure,
            vSelect,
            Datepicker,
        },

        data() {
            return {

                vpisniki: [],
                povezaniSistemi: [],
                rokHrambe: [],
                vrstaGradiva: [],

                classificationPlan: [],
                classificationPlanFilteredStore: this.$store.getters.getClassificationPlanFiltered,

                // used on dropdown when selecting filters, used for v-select
                filterOptionsLabel: [],
                filterOptionsLabelName: [],
                filterOptionsPovezaniSistemi: [],
                filterOptionsRokHrambe: [],
                filterOptionsVrstaGradiva: [],
                filterOptionsVpisnik: [],
                filterOptionsCreationDate: [],
                filterOptionsUsageEndDate: [],
                filterOptionsParentClass: [],

                //classes we put filters in and then filter them to othe
                filteredClasses: [],
                filteredClasses1: [],
                filteredClasses2: [],

                // all filtered classes, no hierarchy
                filteredClassesFinal: [],

                // labels of classes we got through filter
                filteredClassesFinalLabels: [],
                filters: {},  // objekt filtrov
                showFilters: true,

                // posamezni filtri
                selectedLabel: "",
                selectedLabelName: "",
                selectedPovezaniSistemi: "",
                selectedRokHrambe: "",
                selectedVpisnik: "",
                selectedCreationDate: "",
                selectedUsageEndDate: "",
                selectedFilter: "",
                initialMount: true,
                constructedClasses: [],  // result after filtering
                CurrentFiltersCopy: {}, // set filters before we click "Potrdi"


            }

        },


        // watcher the default value on v-select on clicking x on filter to "none", we use "none" as no filter
        watch: {
            'filters.label': function () {
                if (this.filters.label == null) {
                    this.filters.label = "none";
                }
            },

            'filters.labelName': function () {
                if (this.filters.labelName == null) {
                    this.filters.labelName = "none";
                }
            },

            'filters.povezaniSistemi': function () {
                if (this.filters.povezaniSistemi == null) {
                    this.filters.povezaniSistemi = "none";
                }
            },

            'filters.rokHrambe': function () {
                if (this.filters.rokHrambe == null) {
                    this.filters.rokHrambe = "none";
                }
            },

            'filters.vpisnik': function () {
                if (this.filters.vpisnik == null) {
                    this.filters.vpisnik = "none";
                }
            },

            /*'filters.creationDate': function () {
                if (this.filters.creationDate == null) {
                    this.filters.creationDate = "none";
                }
            },


            'filters.usageEndDate': function () {
                if (this.filters.usageEndDate == null) {
                    this.filters.usageEndDate = "none";
                }
            },
            */

            'filters.vrstaGradiva': function () {
                if (this.filters.vrstaGradiva == null) {
                    this.filters.vrstaGradiva = "none";
                }
            },
            classificationPlan: function () {
                //console.log("changed", this.classificationPlan);
            },

            cloned: function () {
                console.log("clone changed");
            }


        },

        mounted() {

            console.log("classificationPlanFiltered mounted");

            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                    if(modalId === this.modalName) {
                        if(bvEvent.trigger === "backdrop") {
                            this.cancelChanges();
                        }
                    }
            });


            this.vpisniki = this.$store.getters.getRegisterOptions;
            this.rokHrambe = this.$store.getters.getStorageDateOptions;
            this.vrstaGradiva = this.$store.getters.getDocumentTypeOptions;


            let ehrambaPovezaniSistemi = [];
            _.each(this.$store.getters.getConnectedSystemsOptions, function (innerItem) {
                if(innerItem.ehramba) {
                    ehrambaPovezaniSistemi.push(innerItem);
                }
            });
            this.povezaniSistemi = ehrambaPovezaniSistemi;


            this.classificationPlan = this.$store.getters.getClassificationPlan;
            this.filters = _.cloneDeep(this.$store.getters.getFilters);
            //console.log(this.filters);
            this.setFilterOptions();
            this.filter();

        },

        computed: {},


        // when the classificationPlan updates on a page we need to update as well
        updated() {
            //console.log("classificationPlanFilter updated");
            if (this.classificationPlan.length === 0) {
                this.classificationPlan = this.$store.getters.getClassificationPlan;
                this.classificationPlanFilteredStore = this.$store.getters.getClassificationPlanFiltered;
                this.filter();
            }
        },

        methods: {

            emitCheckAll(check){
                this.$root.$emit('checkAll', check);
            },

            getRegisterItemReadableLabel(registerId) {
                const _this = this;
                return _.filter(_this.vpisniki, {'id': registerId.toString()})[0].description;
            },

            getRegisterItemId(registerLabel) {
                const _this = this;
                return _.filter(_this.vpisniki, {'description': registerLabel.toString()})[0].id;
            },

            getConnectedSystemReadableLabel(connectedSystemId) {
                console.log("connected system id", connectedSystemId);
                const _this = this;
                return _.filter(_this.povezaniSistemi, {'id': connectedSystemId.toString()})[0].description;
            },


            getVrstaGradivaReadableLabel(vrstaGradivaId) {



                if( vrstaGradivaId == null){
                    return null;
                }
                else{
                    const _this = this;


                    for(let i = 0; i< this.vrstaGradiva.length; i++){
                        if(this.vrstaGradiva[i].id.toString() === vrstaGradivaId.toString()){
                            return this.vrstaGradiva[i].description;
                        }

                    }

                    return null;
                }

            },

            getRokHrambeReadableLabel(rokHrambeType) {



                if( rokHrambeType == null){
                    return null;
                }
                else{

                    for(let i = 0; i< this.rokHrambe.length; i++){
                        if(this.rokHrambe[i].type.toString() === rokHrambeType.toString()){
                            return this.rokHrambe[i].explanation;
                        }

                    }

                    return null;
                }

            },


            getConnectedSystemId(connectedSystemDescription) {
                const _this = this;
                return _.filter(_this.povezaniSistemi, {'description': connectedSystemDescription.toString()})[0].id;
            },

            // emits event to update potential other filters on a page
            updateFilter() {

                this.$root.$emit("updateFilter", this.id);
            },


            // updates classificationPlanFilteredStore
            updateFilterPlan() {

                this.classificationPlanFilteredStore = this.$store.getters.getClassificationPlanFiltered;
            },


            // on modal filters, if we click "Preklici", we compare temp filters to filter currently being used, if not the same we
            cancelChanges() {

                console.log("cancel changes");
                console.log(this.CurrentFiltersCopy, this.filters);
                for (let key in this.CurrentFiltersCopy) {
                    if (this.CurrentFiltersCopy[key] !== this.filters[key]) {
                        this.filters[key] = this.CurrentFiltersCopy[key];
                    }
                }
            },


            // sets copy for current filters, called on filters modal open

            setCurrentFiltersCopy() {
                this.CurrentFiltersCopy = _.cloneDeep(this.filters);
            },

            modalClose() {
                /*this.filters.label = "none";
                this.filters.labelName = "none";
                this.filters.povezaniSistemi = "none";
                this.filters.vpisnik = "none";
                this.filters.rokHrambe = "none";
                this.filters.creationDate = "none";
                this.filters.usageEndDate = "none";
                this.filters.vrstaGradiva = "none";
                */
            },


            // sets v-select options for every category, called in mounted

            setFilterOptions() {
                for (let i = 0; i < this.classificationPlan.length; i++) {
                    this.setFilterOptionsRec(this.classificationPlan[i]);

                }
                this.filterOptionsVpisnik.sort(function (a, b) {
                    if (a > b)
                        return 1;
                    if (a < b)
                        return -1;
                    // a must be equal to b
                    return 0;
                });

                this.filterOptionsPovezaniSistemi.sort(function (a, b) {
                    if (a > b)
                        return 1;
                    if (a < b)
                        return -1;
                    // a must be equal to b
                    return 0;
                });

                this.filterOptionsRokHrambe.sort(function (a, b) {
                    if (a > b)
                        return 1;
                    if (a < b)
                        return -1;
                    // a must be equal to b
                    return 0;
                });

                this.filterOptionsLabel.sort(function (a, b) {
                    if (a > b)
                        return 1;
                    if (a < b)
                        return -1;
                    // a must be equal to b
                    return 0;
                });

                this.filterOptionsLabelName.sort(function (a, b) {
                    if (a > b)
                        return 1;
                    if (a < b)
                        return -1;
                    // a must be equal to b
                    return 0;
                });

                this.filterOptionsVrstaGradiva.sort(function (a, b) {
                    if (a > b)
                        return 1;
                    if (a < b)
                        return -1;
                    // a must be equal to b
                    return 0;
                });
                return;
            },

            setFilterOptionsRec(classificationPlan) {

                let label = classificationPlan.classificationLabel;
                let labelName = classificationPlan.classificationLabelName;
                let povezaniSistemi = classificationPlan.povezaniSistemi;
                let rokHrambe = classificationPlan.rokHrambe;
                let vpisnik = classificationPlan.vpisnik;
                //let creationDate = classificationPlan.creationDate;

                //let usageEndDate = classificationPlan.usageEndDate;
                let parentClass = classificationPlan.parentClass;
                this.filterOptionsLabel.push(label);

                if (!this.filterOptionsLabelName.includes(labelName) && !(labelName == null)) {
                    this.filterOptionsLabelName.push(labelName);
                }
                for (let i = 0; i < povezaniSistemi.length; i++) {
                    if (!this.filterOptionsPovezaniSistemi.includes(this.getConnectedSystemReadableLabel(povezaniSistemi[i]))) {
                        this.filterOptionsPovezaniSistemi.push(this.getConnectedSystemReadableLabel(povezaniSistemi[i]));
                    }
                }
                for (let i = 0; i < rokHrambe.length; i++) {
                    if (!this.filterOptionsRokHrambe.includes(this.getRokHrambeReadableLabel(rokHrambe[i].expiration)) && !(rokHrambe[i].expiration == null)) {
                        this.filterOptionsRokHrambe.push(this.getRokHrambeReadableLabel(rokHrambe[i].expiration));
                    }
                    if (!this.filterOptionsVrstaGradiva.includes(this.getVrstaGradivaReadableLabel(rokHrambe[i].expirationType)) && rokHrambe[i].isGeneral != true && !(rokHrambe[i].expirationType == null)) {
                        this.filterOptionsVrstaGradiva.push(this.getVrstaGradivaReadableLabel(rokHrambe[i].expirationType));
                    }
                }
                for (let i = 0; i < vpisnik.length; i++) {
                    if (!this.filterOptionsVpisnik.includes(this.getRegisterItemReadableLabel(vpisnik[i]))) {
                        this.filterOptionsVpisnik.push(this.getRegisterItemReadableLabel(vpisnik[i]));
                    }
                }
               /* if (!this.filterOptionsCreationDate.includes(creationDate) && !(creationDate == null)) {
                    this.filterOptionsCreationDate.push(creationDate);
                }

                if (!this.filterOptionsUsageEndDate.includes(usageEndDate) && !(usageEndDate == null)) {
                    this.filterOptionsUsageEndDate.push(usageEndDate);
                }

                if (!this.filterOptionsParentClass.includes(parentClass)&& !(parentClass == null)) {
                    this.filterOptionsParentClass.push(parentClass);
                }

                */
                this.filteredClasses.push(classificationPlan);



                for (let i = 0; i < classificationPlan.item.length; i++) {
                    this.setFilterOptionsRec(classificationPlan.item[i]);
                }
                return;
            },

            // filters the classificationPlan through current filters
            // rough overview of how it works: get all classes -> filters through filter1, saves result in filteredClasses1 -> filters filteredClasses1 through filter2,
            // saves result in filteredClasses2; then it just repeats the process, result is all classes that passed the filters in one array
            filter() {
                this.filteredClassesFinalLabels = [];
                this.initialMount = true;
                //console.log("filter");
                //console.log(this.filteredClasses);
                this.filteredClasses1 = [];
                this.filteredClasses2 = [];
                this.filteredClassesFinal = [];
                let copy = _.cloneDeep(this.filteredClasses);
                let copy2 = _.cloneDeep(this.classificationPlan);
                //console.log("copy ->", copy);
                //console.log("copy2 ->", copy2);
                if (this.filters.label !== "none") {
                    this.filterLabel(copy);
                    this.initialMount = false;
                } else {
                    this.filteredClasses1 = _.cloneDeep(this.filteredClasses);
                }
                //console.log("filteredClasses1 po labelu", this.filteredClasses1);

                if (this.filters.labelName !== "none") {
                    this.filterLabelName(this.filteredClasses1);
                    this.initialMount = false;

                } else {
                    this.filteredClasses2 = this.filteredClasses1;
                }

                this.filteredClasses1 = [];

                //console.log("filteredClasses2 po namu", this.filteredClasses2);

                if (this.filters.povezaniSistemi !== "none") {
                    this.filterPovezaniSistemi(this.filteredClasses2);
                    this.initialMount = false;
                } else {
                    this.filteredClasses1 = this.filteredClasses2;
                }

                this.filteredClasses2 = [];

                //console.log("filteredClasses1 po povezanih sistemih", this.filteredClasses1);

                if (this.filters.rokHrambe !== "none" || this.filters.vrstaGradiva !== "none") {
                    this.filterRokHrambe(this.filteredClasses1);
                    this.initialMount = false;
                } else {
                    this.filteredClasses2 = this.filteredClasses1;
                }

                this.filteredClasses1 = [];

                //console.log("filteredClasses2 po rok hrambe", this.filteredClasses2);

                if (this.filters.vpisnik !== "none") {
                    this.filterVpisnik(this.filteredClasses2);
                    this.initialMount = false;
                } else {
                    this.filteredClasses1 = this.filteredClasses2;
                }

                this.filteredClasses2 = [];

                //console.log("filteredClasses1 po vpisniku", this.filteredClasses1);

                if (this.filters.creationDate.start != null || this.filters.creationDate.end != null) {
                    this.filterCreationDate(this.filteredClasses1);
                    this.initialMount = false;
                } else {
                    this.filteredClasses2 = this.filteredClasses1;
                }

                this.filteredClasses1 = [];

                //console.log("filteredClasses2 po creation datu", this.filteredClasses2);

                this.filteredClasses1 = this.filteredClasses2;

                this.filteredClasses2 = [];

                //console.log("filteredClasses1 po usage start datu", this.filteredClasses1);

                if (this.filters.usageEndDate.start != null || this.filters.usageEndDate.end != null) {
                    this.filterUsageEndDate(this.filteredClasses1);
                    this.initialMount = false;
                } else {
                    this.filteredClasses2 = this.filteredClasses1;
                }

                this.filteredClasses1 = [];

                //console.log("filteredClasses2 after usage end date", this.filteredClasses2);
                for (let i = 0; i < this.filteredClasses2.length; i++) {
                    this.filteredClassesFinalLabels.push(this.filteredClasses2[i].classificationLabel);
                }

                this.filteredClassesFinal = this.filteredClasses2;
                this.constructPlan(copy2);
                this.$store.dispatch("setFilters", this.filters);
                this.$store.dispatch("setClassificationPlanFiltered", this.constructedClasses);
                this.updateFilterPlan();

            },


            // from classes that got through filter reconstructs hierarchy as it was in the non-filtered classification plan

            constructPlan(classificationPlan) {

                console.log("we are constructing a plan!");
                console.log("filtered classes labels: ", this.filteredClassesFinalLabels);



                this.constructedClasses = classificationPlan;
                //console.log("this.filteredClassesFinalLabels", this.filteredClassesFinalLabels);
                //console.log("constructPlan", classificationPlan);
                for (let i = this.constructedClasses.length-1; i >= 0; i--) {
                    if (this.constructPlanRec(this.constructedClasses[i]) === false) {
                        this.constructedClasses.splice(i, 1);
                    }
                }

                //console.log("constructedClasses", this.constructedClasses);
                if (this.toExport) {
                    this.$root.$emit('setClassificationPlanExport', this.constructedClasses);
                }
                if (this.toPrint) {
                    this.$root.$emit('setClassificationPlanPrint', this.constructedClasses);
                }


            },

            constructPlanRec(classificationPlan) {
                let bool = false;


                classificationPlan.structure.match = this.filteredClassesFinalLabels.includes(classificationPlan.classificationLabel);


                if(classificationPlan.item.length === 0){
                    if (classificationPlan.structure.match) {
                        return true;
                    }
                    else{

                        return false;
                    }
                }

                for (let i = classificationPlan.item.length-1; i>=0 ; i--) {
                    if (this.constructPlanRec(classificationPlan.item[i]) == false) {
                        classificationPlan.item.splice(i, 1);
                    } else {
                        bool = true;
                    }
                }
                //console.log(classificationPlan.classificationLabel + " " + bool);
                if(bool === false && classificationPlan.structure.match){
                    return true;
                }
                else {
                    return bool;
                }
            },


            // filters for every category, each one just checks the field and pushes to the right array

            filterLabel(classificationPlan) {
                //console.log(classificationPlan);
                for (let i = 0; i < classificationPlan.length; i++) {
                    if (classificationPlan[i].classificationLabel === this.filters.label) {
                        classificationPlan[i].structure.isOpen = false;
                        this.filteredClasses1.push(classificationPlan[i]);
                    }
                }
            },

            filterLabelName(classificationPlan) {
                for (let i = 0; i < classificationPlan.length; i++) {
                    if (classificationPlan[i].classificationLabelName === this.filters.labelName) {
                        classificationPlan[i].structure.isOpen = false;
                        this.filteredClasses2.push(classificationPlan[i]);
                    }
                }

                return;
            },

            filterPovezaniSistemi(classificationPlan) {
                for (let i = 0; i < classificationPlan.length; i++) {
                    for (let j = 0; j < classificationPlan[i].povezaniSistemi.length; j++) {
                        if (classificationPlan[i].povezaniSistemi[j] === this.getConnectedSystemId(this.filters.povezaniSistemi)) {
                            classificationPlan[i].structure.isOpen = false;
                            this.filteredClasses1.push(classificationPlan[i]);
                        }
                    }
                }

                return;
            },

            filterRokHrambe(classificationPlan) {
                console.log(this.filters.rokHrambe);
                for (let i = 0; i < classificationPlan.length; i++) {
                    for (let j = 0; j < classificationPlan[i].rokHrambe.length; j++) {
                        let checkRokHrambe = this.checkExpiration(this.filters.rokHrambe, classificationPlan[i].rokHrambe[j].expiration);
                        let checkExpirationType = this.checkExpirationType(this.filters.vrstaGradiva, classificationPlan[i].rokHrambe[j].expirationType);
                        if (checkRokHrambe === true || checkExpirationType) {
                            classificationPlan[i].structure.isOpen = false;
                            this.filteredClasses2.push(classificationPlan[i]);
                        }
                    }
                }

                return;
            },

            // function that checks expiration of a plan and compares it with a filter
            checkExpiration(filtersExpiration, planExpiration) {
                let expiration = this.getRokHrambeReadableLabel(planExpiration);
                if(filtersExpiration === expiration) {
                    return true;
                }
                return false;


            },

            //function that checks expirationType of a plan and compares it with a filter

            checkExpirationType(filtersExpirationType, planExpirationType) {
                let expirationType = this.getVrstaGradivaReadableLabel(planExpirationType);
                if(filtersExpirationType === expirationType) {
                    return true;
                }
                return false;
            },

            filterVpisnik(classificationPlan) {
                for (let i = 0; i < classificationPlan.length; i++) {
                    for (let j = 0; j < classificationPlan[i].vpisnik.length; j++) {
                        if (classificationPlan[i].vpisnik[j] === this.getRegisterItemId(this.filters.vpisnik)) {
                            classificationPlan[i].structure.isOpen = false;
                            this.filteredClasses1.push(classificationPlan[i]);
                        }
                    }
                }

                return;
            },

            filterCreationDate(classificationPlan) {
                let upperDateAcc = this.filters.creationDate.end;
                let lowerDateAcc = this.filters.creationDate.start;

                if(this.filters.creationDate.end != null) {

                    let upperDate = this.filters.creationDate.end;
                    let upperDateParts = upperDate.split("/");
                    let upperDateCorr = upperDateParts[1] + "/" + upperDateParts[0] + "/" + upperDateParts[2];
                    upperDateAcc = new Date(upperDateCorr);
                }

                if(this.filters.creationDate.start != null) {
                    let lowerDate = this.filters.creationDate.start;
                    let lowerDateParts = lowerDate.split("/");
                    let lowerDateCorr = lowerDateParts[1] + "/" + lowerDateParts[0] + "/" + lowerDateParts[2];
                    lowerDateAcc = new Date(lowerDateCorr);
                }


                for (let i = 0; i < classificationPlan.length; i++) {
                    let date = classificationPlan[i].creationDate;
                    console.log(date);
                    let dateParts = date.split("-");
                    let dateCorr = dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
                    let dateAcc = new Date(dateCorr);
                    console.log(dateAcc);
                    let lowEnough = this.filters.creationDate.end != null ? dateAcc <= upperDateAcc : true;
                    let highEnough = this.filters.creationDate.start != null ? dateAcc >= lowerDateAcc : true;
                    console.log(dateAcc >= lowerDateAcc, dateAcc <= upperDateAcc);
                    console.log(lowEnough, highEnough);
                    if(lowEnough && highEnough) {
                        classificationPlan[i].structure.isOpen = false;
                        this.filteredClasses2.push(classificationPlan[i]);
                    }
                }

                return;
            },

            filterUsageEndDate(classificationPlan) {

                let upperDateAcc = this.filters.usageEndDate.end;
                let lowerDateAcc = this.filters.usageEndDate.start;

                if(this.filters.usageEndDate.end != null) {

                    let upperDate = this.filters.usageEndDate.end;
                    let upperDateParts = upperDate.split("/");
                    let upperDateCorr = upperDateParts[1] + "/" + upperDateParts[0] + "/" + upperDateParts[2];
                    upperDateAcc = new Date(upperDateCorr);
                }

                if(this.filters.usageEndDate.start != null) {
                    let lowerDate = this.filters.usageEndDate.start;
                    let lowerDateParts = lowerDate.split("/");
                    let lowerDateCorr = lowerDateParts[1] + "/" + lowerDateParts[0] + "/" + lowerDateParts[2];
                    lowerDateAcc = new Date(lowerDateCorr);
                }

                for (let i = 0; i < classificationPlan.length; i++) {
                    let date = classificationPlan[i].usageEndDate;
                    if(date != null) {
                        console.log(date);
                        let dateParts = date.split("-");
                        let dateCorr = dateParts[1] + "/" + dateParts[0] + "/" + dateParts[2];
                        let dateAcc = new Date(dateCorr);
                        console.log(dateAcc);
                        let lowEnough = this.filters.usageEndDate.end != null ? dateAcc <= upperDateAcc : true;
                        let highEnough = this.filters.usageEndDate.start != null ? dateAcc >= lowerDateAcc : true;
                        console.log(dateAcc >= lowerDateAcc, dateAcc <= upperDateAcc);
                        console.log(lowEnough, highEnough);
                        if (lowEnough && highEnough) {
                            classificationPlan[i].structure.isOpen = false;
                            this.filteredClasses2.push(classificationPlan[i]);
                        }
                    }
                }

                return;
            },


            // clear functions, called when we click x on buttons that appear if a filter is present on page, it clears that filter

            clearLabel() {
                this.filters.label = "none";
                this.filter();
                this.updateFilter();
            },

            clearLabelName() {
                this.filters.labelName = "none";
                this.filter();
                this.updateFilter();
            },

            clearPovezaniSistemi() {
                this.filters.povezaniSistemi = "none";
                this.filter();
                this.updateFilter();
            },

            clearRokHrambe() {
                this.filters.rokHrambe = "none";
                this.filter();
                this.updateFilter();
            },

            clearVpisnik() {
                this.filters.vpisnik = "none";
                this.filter();
                this.updateFilter();
            },

            clearCreationDate() {
                this.filters.creationDate.start = null;
                this.filters.creationDate.end = null;
                this.filter();
                this.updateFilter();
            },

            clearUsageEndDate() {
                this.filters.usageEndDate.start = null;
                this.filters.usageEndDate.end = null;
                this.filter();
                this.updateFilter();
            },

            clearVrstaGradiva() {
                this.filters.vrstaGradiva = "none";
                this.filter();
                this.updateFilter();
            },

            clearAllFilters() {
              this.filters.label = "none";
              this.filters.labelName = "none";
              this.filters.povezaniSistemi = "none";
              this.filters.rokHrambe = "none";
              this.filters.vpisnik = "none";
              this.filters.creationDate.start = null;
              this.filters.creationDate.end = null;
              this.filters.usageEndDate.start = null;
              this.filters.usageEndDate.end = null;
              this.filters.vrstaGradiva = "none";
              this.filter();
              this.updateFilter();
            }


        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ClassificationPlanFilter.vue